import { Sun, Wind, Droplet, Thermometer, type LucideIcon } from "lucide-react"
import { Badge } from "@/components/ui/badge"
import { KIND_LABEL_PT, type Kind } from "@/lib/kind-labels"
import { cn } from "@/lib/utils"

interface KindMeta {
  Icon: LucideIcon
  color: string
}

export const KIND_META: Record<Kind, KindMeta> = {
  solar: { Icon: Sun, color: "text-amber-500" },
  ac: { Icon: Wind, color: "text-sky-500" },
  bc_aqs: { Icon: Droplet, color: "text-blue-500" },
  bc_aq: { Icon: Thermometer, color: "text-rose-500" },
}

interface ProposalKindChipProps {
  kind: Kind
  className?: string
}

export function ProposalKindChip({ kind, className }: ProposalKindChipProps) {
  const meta = KIND_META[kind]
  const Icon = meta.Icon
  return (
    <Badge variant="outline" className={cn("gap-1", className)}>
      <Icon className={cn("h-3 w-3", meta.color)} />
      {KIND_LABEL_PT[kind]}
    </Badge>
  )
}
